import React from 'react';
import { useSettings } from '../hooks/useSettings';

const API_BASE = process.env.REACT_APP_API_URL?.replace('/api', '') || '';

export function DocHeader({ docType = 'BILL' }) {
  const { settings } = useSettings();
  const primary = settings.primary_color || '#2563eb';

  // If a header image is uploaded, just show it full-width
  if (settings.header_image) {
    return (
      <div style={{ width: '100%' }}>
        <img
          src={`${API_BASE}${settings.header_image}`}
          alt="Header"
          style={{ width: '100%', display: 'block' }}
        />
      </div>
    );
  }

  // Otherwise show the dynamic text header
  return (
    <>
      <div className="doc-header">
        <div className="doc-header-top">
          <div>
            {settings.company_logo ? (
              <img src={`${API_BASE}${settings.company_logo}`} alt="Logo" className="doc-logo" />
            ) : (
              <div className="doc-company-name" style={{ color: primary }}>{settings.company_name}</div>
            )}
            {settings.company_logo && (
              <div className="doc-company-name" style={{ color: primary, marginTop: 4 }}>{settings.company_name}</div>
            )}
            {settings.company_tagline && <div className="doc-tagline">{settings.company_tagline}</div>}
          </div>
          <div className="doc-title">{docType}</div>
        </div>
      </div>
      <hr className="doc-divider" style={{ background: `linear-gradient(90deg, #cbd5e1 0%, ${primary} 40%, ${primary} 100%)` }} />
    </>
  );
}

export function DocFooter() {
  const { settings } = useSettings();
  const primary = settings.primary_color || '#2563eb';

  // If a footer image is uploaded, just show it full-width
  if (settings.footer_image) {
    return (
      <div style={{ width: '100%' }}>
        <img
          src={`${API_BASE}${settings.footer_image}`}
          alt="Footer"
          style={{ width: '100%', display: 'block' }}
        />
      </div>
    );
  }

  // Otherwise show the dynamic text footer
  return (
    <div className="doc-footer">
      {settings.footer_note && (
        <p style={{ textAlign: 'center', fontSize: 13, color: '#64748b', marginBottom: 12, fontStyle: 'italic' }}>
          {settings.footer_note}
        </p>
      )}
      <div className="doc-footer-contacts">
        {(settings.phone1 || settings.phone2) && (
          <div className="doc-footer-contact">
            <span>📞</span>
            <div>
              {settings.phone1 && <div>{settings.phone1}</div>}
              {settings.phone2 && <div>{settings.phone2}</div>}
            </div>
          </div>
        )}
        {(settings.email1 || settings.email2) && (
          <div className="doc-footer-contact">
            <span>✉️</span>
            <div>
              {settings.email1 && <div>{settings.email1}</div>}
              {settings.email2 && <div>{settings.email2}</div>}
            </div>
          </div>
        )}
        {settings.address && (
          <div className="doc-footer-contact">
            <span>📍</span>
            <div style={{ maxWidth: 180 }}>{settings.address}</div>
          </div>
        )}
      </div>
      {settings.website && (
        <div className="doc-footer-website" style={{ background: primary }}>{settings.website}</div>
      )}
    </div>
  );
}